import { render, staticRenderFns } from "./PaapCentralizationReports.vue?vue&type=template&id=67aeb458"
import script from "./PaapCentralizationReports.vue?vue&type=script&lang=js"
export * from "./PaapCentralizationReports.vue?vue&type=script&lang=js"
import style0 from "./PaapCentralizationReports.vue?vue&type=style&index=0&id=67aeb458&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports